import { useTranslation } from "react-i18next";
import countries from "../utils/i18n-iso-countries-registered";

export function useCountryArr() {
  const { i18n } = useTranslation();
  let countryObj;
  if (i18n.language === "de-DE") {
    // Returns an object not a list
    countryObj = countries.getNames("de", { select: "official" });
  } else if (i18n.language === "es-ES") {
    // Returns an object not a list
    countryObj = countries.getNames("es", { select: "official" });
  } else {
    countryObj = countries.getNames("en", { select: "official" });
  }
  // TODO: Wrap in Useeffect ?
  // https://en.wikipedia.org/wiki/ISO_3166-1#Officially_assigned_code_elements
  const countryArr = Object.entries(countryObj).map(([key, value]) => {
    return {
      label: value,
      value: key,
    };
  });
  return countryArr;
}
